class DepartmentSerializer {
  static deSerialize(data) {
    return {
      id: data.Key,
      name: data.Value,
    };
  }
}

export { DepartmentSerializer };



// WEBPACK FOOTER //
// ./src/networking/serializers/DepartmentSerializer.js